import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'

const LinkButton = (props) => {
  const navigate = useNavigate()
  const { to, onClick, disabled, className, ...rest } = props

  // const obtenerClases = () => (disabled ? "btn btn-disabled" : className);

  return (
    <button
      type="button"
      className={`${className || 'btn'} ${disabled ? 'btn-disabled' : ''}`.trim()}
      disabled={disabled}
      aria-disabled={disabled}
      {...rest}
      onClick={(event) => {
        onClick && onClick(event)
        if (to) {
          if (typeof to === 'string') {
            navigate(to)
          } else if (typeof to === 'object') {
            // Handle object with pathname and state
            navigate(to.pathname, { state: to.state })
          }
        }
      }}
    />
  )
}

LinkButton.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      state: PropTypes.object
    })
  ]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string
}

export default LinkButton
